import { render, staticRenderFns } from "./BulkNewForm.vue?vue&type=template&id=394b80f0"
import script from "./BulkNewForm.vue?vue&type=script&lang=js"
export * from "./BulkNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports